export default [
    {
        path: '/admin',
        name: 'admin',
        component: () => import('@/pages/Admin/Main'),
    },
    {
        path: '/regions',
        name: 'regions',
        component: () => import('@/pages/Admin/Regions'),
    },
    {
        path: '/co',
        name: 'co',
        component: () => import('@/pages/Admin/Co'),
    },
    {
        path: '/organizations',
        name: 'organizations',
        component: () => import('@/pages/Admin/Organizations'),
    },
    {
        path: '/appeals-org',
        name: 'appeals-org',
        component: () => import('@/pages/Admin/OrgAppeals'),
    },
    {
        path: '/appeals-fives',
        name: 'appeals-fives',
        component: () => import('@/pages/Admin/FormsFiveAppeals'),
    },
    {
        path: '/appeals-indicators',
        name: 'appeals-indicators',
        component: () => import('@/pages/Admin/ViewIndicatorsAppeals'),
    },
    {
        path: '/founders',
        name: 'founders',
        component: () => import('@/pages/Admin/Founders'),
    },
    {
        path: '/envelopes',
        name: 'envelopes',
        component: () => import('@/pages/Admin/Envelopes'),
    },
    {
        path: '/cryptotest',
        name: 'cryptotest',
        component: () => import('@/pages/Admin/CryptoTest'),
    },
].map(el => ({...el,
    meta: {
        needContact: false,
        isAdmin: true
    }
}))